<template>
    <div class="panel_izda ficha">
        <service
            :ws='ws'
            :data="data"
            :spinner="ws_spinner"
            @success='onSuccess'
            @error='console.log($event)'
        />
        <div class="row back_route" @click="$router.push({ name: 'Usuarios'})">
            <svg width="16" height="8" viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.646445 3.64645C0.451183 3.84171 0.451183 4.15829 0.646445 4.35355L3.82843 7.53553C4.02369 7.7308 4.34027 7.7308 4.53553 7.53553C4.73079 7.34027 4.73079 7.02369 4.53553 6.82843L1.70711 4L4.53553 1.17157C4.73079 0.976311 4.73079 0.659728 4.53553 0.464466C4.34027 0.269204 4.02369 0.269204 3.82843 0.464466L0.646445 3.64645ZM16 3.5L0.999999 3.5V4.5L16 4.5V3.5Z" fill="#4F4F4F"/>
            </svg>
            <span class="parrafo">{{ $t(localeRoute + 'backToUsers') }}</span>
        </div>
        <span class="tipo" :style="{'background-color': 'var(--color_' + usuario.tipo + ')' }">{{usuario.tipo}}</span>
        <div class="user-info-wrapper">
            <div class="foto">
                <span class="finalizado" v-if="this.usuario.estado == 1">
                    <p class="parrafo bold">{{ $t(localeRoute + 'ended') }}</p>
                </span>
                <img class="avatar" :src="usuario.personales.foto || 'images/avatar_placeholder.jpg'"/>
            </div>
            <div class="user-wrapper">
                <p class="parrafo bold nombre">{{usuario.personales.nombre + ' ' + usuario.personales.apellidos}}</p>
                <div class="acciones_rapidas" v-if="usuario_loggeado.tipo != 'RRHH'">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <svg v-if="usuario.estado != 1" v-on="on" class="icono enlace" @click="copyToClipboard" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7.36349 13.7195L5.27276 15.8393C4.40596 16.7182 3.00174 16.7182 2.13494 15.8393C1.26813 14.9605 1.26813 13.5367 2.13494 12.6579L6.31986 8.41486C7.18666 7.53601 8.59089 7.53601 9.45769 8.41486C9.74547 8.70663 10.2135 8.70663 10.5048 8.41486C10.7926 8.12308 10.7926 7.64851 10.5048 7.35322C9.05896 5.88731 6.71859 5.88731 5.27623 7.35322L1.08437 11.5998C-0.361457 13.0657 -0.361457 15.4386 1.08437 16.901C2.52673 18.3669 4.87057 18.3669 6.31639 16.901L8.40712 14.7812C8.6949 14.4894 8.6949 14.0148 8.40712 13.7195C8.11934 13.4243 7.65127 13.4278 7.36349 13.7195Z" fill="#4F4F4F"/>
                                <path d="M16.6693 1.09943C15.2235 -0.366477 12.8831 -0.366477 11.4373 1.09943L8.927 3.64456C8.63923 3.93633 8.63923 4.41091 8.927 4.7062C9.21478 4.99797 9.68286 4.99797 9.9741 4.7062L12.4844 2.16107C13.3512 1.28223 14.7554 1.28223 15.6222 2.16107C16.489 3.03991 16.489 4.46364 15.6222 5.34248L11.0212 10.0074C10.1544 10.8862 8.75018 10.8862 7.88337 10.0074C7.5956 9.7156 7.12752 9.7156 6.83628 10.0074C6.54503 10.2991 6.5485 10.7737 6.83628 11.069C8.2821 12.5349 10.6225 12.5349 12.0648 11.069L16.6658 6.40412C18.1151 4.93821 18.1151 2.56534 16.6693 1.09943Z" fill="#4F4F4F"/>
                            </svg>
                        </template>
                        <span>{{ $t(localeRoute + 'copyActivationLink') }}</span>
                    </v-tooltip>
                    <input class="link_copy" id="link_copy" type="text" :value="`https://stepsrelocation-panel.com/#/?userId=${usuario.enc_id}`" />
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <svg v-if="usuario.estado == 1" v-on="on" @click="enviarEncuesta" class="icono enlace" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.9367 3.53246C20.087 3.9833 19.9637 4.47266 19.6246 4.80404L18.3993 6.00241C18.3068 6.09104 18.2644 6.22205 18.2875 6.34921L18.5765 8.03309C18.6574 8.50319 18.4686 8.96558 18.0833 9.24687C17.8637 9.40486 17.6093 9.48578 17.355 9.48578C17.1585 9.48578 16.962 9.43954 16.777 9.34321L15.2627 8.54943C15.1471 8.48778 15.0122 8.48778 14.8966 8.54943L13.3823 9.34321C13.2051 9.43569 13.0047 9.48578 12.8043 9.48578C12.5423 9.48578 12.2918 9.40101 12.076 9.24687C11.6907 8.96558 11.5019 8.50319 11.5828 8.03309L11.8718 6.34921C11.8949 6.22205 11.8526 6.09104 11.7601 6.00241L10.5347 4.8079C10.1956 4.47652 10.0762 3.98715 10.2226 3.53632C10.369 3.08548 10.7544 2.76181 11.2245 2.69245L12.9161 2.44584C13.0471 2.42657 13.155 2.34565 13.2128 2.23006L13.968 0.696451C14.1799 0.27259 14.6038 0.00671387 15.0816 0.00671387C15.5556 0.00671387 15.9833 0.27259 16.1913 0.692597L16.9466 2.2262C17.0044 2.3418 17.1161 2.42272 17.2433 2.44199L18.9349 2.6886C19.405 2.75795 19.7903 3.08163 19.9367 3.53246ZM17.7404 8.17181L17.4514 6.48793C17.382 6.08719 17.513 5.67489 17.7943 5.38974L19.0196 4.19523C19.1314 4.08734 19.1661 3.94091 19.1198 3.79449C19.0736 3.64806 18.958 3.55173 18.8039 3.52861L17.1123 3.282C16.7077 3.2242 16.3609 2.96988 16.1798 2.60382L15.4245 1.07022C15.359 0.931501 15.228 0.850582 15.0739 0.850582C14.9198 0.850582 14.7926 0.931501 14.7232 1.07022L13.968 2.60382C13.7869 2.96988 13.4401 3.2242 13.0355 3.282L11.3439 3.52861C11.1898 3.55173 11.0742 3.64806 11.028 3.79449C10.9817 3.94091 11.0164 4.08734 11.1281 4.19523L12.3535 5.38974C12.6463 5.67489 12.7812 6.08719 12.7118 6.48793L12.4228 8.17181C12.3959 8.32209 12.4537 8.46081 12.577 8.55328C12.7003 8.64576 12.8506 8.65732 12.9893 8.58411L14.5036 7.79034C14.8658 7.60152 15.2974 7.60152 15.6596 7.79034L17.1739 8.58411C17.3088 8.65347 17.4629 8.64191 17.5862 8.55328C17.7095 8.46466 17.7673 8.32594 17.7404 8.17181Z" fill="#4F4F4F"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M16.4959 11.7439C16.4959 12.0444 16.4034 12.3334 16.2377 12.58C16.704 12.8459 16.9968 13.343 16.9968 13.8863C16.9968 14.4296 16.704 14.9228 16.2377 15.1848C16.4073 15.4314 16.4959 15.7204 16.4959 16.021C16.4959 16.5951 16.1645 17.1153 15.6559 17.3619C15.8061 17.597 15.8871 17.8744 15.8871 18.1557C15.8871 18.9765 15.2166 19.6469 14.3958 19.6469H7.29426C6.2814 19.6469 5.58417 19.0503 5.21025 18.7304L5.20578 18.726C5.18281 18.7066 5.16065 18.6887 5.14004 18.6722C5.11571 18.6526 5.09354 18.6348 5.07477 18.6181C4.94761 18.5141 4.78962 18.4601 4.63164 18.4601H4.37732V18.7607C4.37732 19.4119 3.84942 19.9398 3.19822 19.9398H1.1791C0.527899 19.9398 0 19.4119 0 18.7607V10.3104C0 9.99832 0.123305 9.70162 0.346795 9.47813C0.570285 9.25464 0.863134 9.13134 1.1791 9.13134H3.19822C3.84942 9.13134 4.37732 9.65924 4.37732 10.3104V10.5224C5.30211 10.5339 5.81845 10.5301 6.43883 9.76713C7.04379 9.01959 7.17095 7.9137 7.17095 7.11993V5.83678C7.17095 5.35898 7.55243 4.9698 8.02638 4.96594H8.04179C8.78933 4.96594 9.50218 5.28962 9.9954 5.8522C10.4848 6.41092 10.7083 7.2124 10.6736 8.30673C10.662 8.72289 10.6466 9.23923 10.5811 9.74015C10.5657 9.86731 10.585 9.99832 10.6428 10.1178L10.6466 10.1216C10.662 10.1563 10.6813 10.2064 10.6967 10.2488L15.0047 10.2526C15.8254 10.2526 16.4959 10.9231 16.4959 11.7439ZM9.87981 10.4877L9.87595 10.4761C9.75265 10.2103 9.70641 9.91741 9.74494 9.63226C9.80659 9.17372 9.82201 8.6805 9.83357 8.28362C9.86054 7.41277 9.71026 6.80396 9.36732 6.41478C9.03979 6.04101 8.54657 5.81752 8.0495 5.81752H8.03794C8.03023 5.81752 8.02252 5.82908 8.02252 5.84064V7.12378C8.02252 8.81537 7.5216 9.78639 7.10159 10.3066C6.23075 11.3817 5.37147 11.3855 4.38118 11.3739V17.6047H4.63549C4.98614 17.6047 5.32908 17.728 5.60652 17.9476C5.65276 17.9862 5.70671 18.0324 5.76065 18.0786C6.09203 18.3638 6.59296 18.7915 7.29426 18.7915H10.5811C10.4848 18.5911 10.4347 18.3715 10.4347 18.148C10.4347 17.5739 10.7661 17.0537 11.2747 16.8071C11.1244 16.572 11.0435 16.2946 11.0435 16.0133C11.0435 15.47 11.3363 14.9768 11.8026 14.7147C11.633 14.4681 11.5444 14.1791 11.5444 13.8786C11.5444 13.578 11.6369 13.289 11.8026 13.0424C11.3363 12.7804 11.0435 12.2872 11.0435 11.7439C11.0435 11.5165 11.0974 11.2969 11.1938 11.0965H10.8894C10.9086 11.5011 10.8277 11.9057 10.6505 12.2987C10.5541 12.5145 10.4 12.7303 10.1804 12.9615L10.1771 12.9648C10.0861 13.0559 9.43471 13.708 8.99355 13.632C8.90107 13.6166 8.77391 13.5626 8.69685 13.3892C8.60052 13.1773 8.7007 12.9268 8.91263 12.8305C9.57146 12.5393 9.84175 12.0212 9.87291 11.9614C9.87473 11.9579 9.87574 11.956 9.87595 11.9558C9.99926 11.6822 10.0532 11.4048 10.0416 11.1312C10.0339 10.9347 9.97999 10.7189 9.87981 10.4877ZM12.5347 12.3874H15.0047C15.3592 12.3874 15.6482 12.0984 15.6482 11.7439C15.6482 11.3894 15.3592 11.1004 15.0047 11.1004H12.5347C12.1802 11.1004 11.8912 11.3894 11.8912 11.7439C11.8912 12.0984 12.1802 12.3874 12.5347 12.3874ZM14.3958 17.5084H11.9259C11.5714 17.5084 11.2824 17.7974 11.2824 18.1519C11.2824 18.5064 11.5714 18.7954 11.9259 18.7954H14.3958C14.7503 18.7954 15.0393 18.5064 15.0393 18.1519C15.0393 17.7974 14.7503 17.5084 14.3958 17.5084ZM12.5347 16.6606H15.0047C15.3592 16.6606 15.6482 16.3716 15.6482 16.0171C15.6482 15.6626 15.3592 15.3736 15.0047 15.3736H12.5347C12.1802 15.3736 11.8912 15.6626 11.8912 16.0171C11.8912 16.3716 12.1802 16.6606 12.5347 16.6606ZM13.0356 14.5259H15.5056C15.8601 14.5259 16.1491 14.2369 16.1491 13.8824C16.1491 13.5279 15.8601 13.2389 15.5056 13.2389H13.0356C12.6811 13.2389 12.3921 13.5279 12.3921 13.8824C12.3921 14.2369 12.6811 14.5259 13.0356 14.5259ZM0.847721 10.3143V18.7645C0.847721 18.9495 0.997999 19.0959 1.1791 19.0959H3.19822C3.38318 19.0959 3.5296 18.9456 3.5296 18.7645V10.3143C3.5296 10.1332 3.37932 9.98291 3.19822 9.98291H1.1791C0.994146 9.98291 0.847721 10.1332 0.847721 10.3143Z" fill="#4F4F4F"/>
                            </svg>
                        </template>
                        <span> {{ $t(localeRoute + 'copyLink') }}</span>
                    </v-tooltip>
                    <input class="link_copy" id="link_copy_encuesta" type="text" :value="link_encuesta" />
                    <svg @click="crearPdf('descargar')" class="icono exportar" width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4724 10.2916L7.23618 17.631L0 10.2916H4.34171C4.3408 10.1973 4.34082 10.1041 4.34171 10.012C4.34671 9.49613 4.37935 9.01548 4.43255 8.56939C4.45404 8.38919 4.47889 8.21463 4.50663 8.04567C4.52104 7.95793 4.53623 7.8717 4.55213 7.78697C4.6672 7.17381 4.81969 6.6394 4.98492 6.18143C5.33301 5.21663 5.73761 4.59107 5.96785 4.28309C6.06899 4.1478 6.13648 4.07379 6.15075 4.05924L6.16257 4.04476L6.19803 4.00162C8.69215 0.982873 11.8486 0.439253 13.6011 0.41122C13.6515 0.410414 13.7007 0.410034 13.7487 0.410034C13.8536 0.410034 13.953 0.411429 14.0466 0.413855C14.3437 0.42156 14.5821 0.439666 14.7503 0.456515L14.7653 0.45803C14.9405 0.475953 15.0352 0.492039 15.0352 0.492039L15.8794 0.656048L15.1558 1.10707C15.0706 1.15833 14.9868 1.20989 14.9043 1.26174L14.883 1.27516C14.7232 1.37608 14.5685 1.47807 14.4187 1.58102C14.2772 1.67834 14.1401 1.77652 14.0073 1.87544C13.9192 1.94106 13.8331 2.00701 13.7487 2.07326C12.4258 3.11263 11.5603 4.22541 10.9996 5.29158C10.8834 5.51262 10.7803 5.73166 10.6889 5.94762C10.561 6.24998 10.4561 6.54632 10.3705 6.83371C10.317 7.01315 10.2711 7.1891 10.2318 7.36085C10.2209 7.40843 10.2105 7.45569 10.2006 7.50261C10.175 7.62406 10.1526 7.74325 10.1332 7.8599C10.117 7.95753 10.1028 8.05339 10.0905 8.14732L10.088 8.16639C10.0322 8.5993 10.0158 8.99087 10.0195 9.32584C10.0242 9.74761 10.0608 10.0797 10.0905 10.2916H14.4724ZM9.53232 10.6941L9.11919 10.791L9.11872 10.789L9.11813 10.7865L9.11661 10.7798L9.11226 10.7599C9.10883 10.7439 9.10436 10.7223 9.09916 10.6953C9.08876 10.6414 9.07539 10.5659 9.0614 10.4709C9.03345 10.281 9.00292 10.012 8.98883 9.67949C8.9607 9.01524 8.99791 8.09085 9.25648 7.03321C9.67043 5.33995 10.644 3.34108 12.7522 1.54025C12.5826 1.56058 12.4062 1.58663 12.2242 1.6196C10.6633 1.90219 8.68688 2.69018 7.01305 4.73882L6.78798 5.01428H6.76367C6.74982 5.03321 6.73518 5.05365 6.71983 5.07562C6.57029 5.28969 6.36543 5.63155 6.16202 6.10708C5.75664 7.05478 5.35589 8.53604 5.41313 10.5988L5.43451 11.3696H2.55743L7.23628 16.1121L11.9151 11.3696H9.25502L9.1192 10.7911C9.11934 10.7914 9.1239 10.7901 9.53233 10.6941L9.53232 10.6941Z" fill="#373737"/>
                    </svg>
                    <svg @click="crearPdf('imprimir')" class="icono imprimir" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.5539 4.56465H15.5811V0.882143C15.5811 0.531428 15.305 0.244141 14.9598 0.244141H4.43843C4.09692 0.244141 3.81717 0.527697 3.81717 0.882143V4.56838H1.8444C1.04513 4.56838 0.398438 5.23623 0.398438 6.05332V12.4595C0.398438 13.2803 1.04876 13.9444 1.8444 13.9444H3.81717V17.362C3.81717 17.7127 4.09328 18 4.43843 18H14.9598C15.3013 18 15.5811 17.7165 15.5811 17.362V13.9444H17.5539C18.3531 13.9444 18.9998 13.2766 18.9998 12.4595V6.05332C18.9998 5.2325 18.3495 4.56465 17.5539 4.56465ZM5.05968 1.51641H14.3422V4.56465H5.05968V1.51641ZM14.3386 16.724H5.05968C5.05968 16.6009 5.05968 11.6685 5.05968 11.5155H14.3422C14.3386 11.6722 14.3386 16.6046 14.3386 16.724ZM17.7609 12.4595C17.7609 12.5751 17.6665 12.6721 17.5539 12.6721H15.5811V10.8812C15.5811 10.5305 15.305 10.2432 14.9598 10.2432H4.43843C4.09692 10.2432 3.81717 10.5268 3.81717 10.8812V12.6721H1.8444C1.73178 12.6721 1.63732 12.5751 1.63732 12.4595V6.05332C1.63732 5.93766 1.73178 5.84065 1.8444 5.84065C2.32034 5.84065 17.0888 5.84065 17.5539 5.84065C17.6665 5.84065 17.7609 5.93766 17.7609 6.05332V12.4595Z" fill="#4F4F4F"/>
                    </svg>
                </div>
            </div>
        </div>
        <v-snackbar
            v-model="snackbar"
            :timeout="2000"
            >
            {{ snackbar_text }}
            <v-btn
                snackbar_text
                @click="snackbar = false"
            >
                {{ $t(localeRoute + 'close') }}
            </v-btn>
        </v-snackbar>
        <div class="wrapper-bloque-panel">
            <div class="bloque empresa" v-if="getEmpresa()">
                <div class="izda">
                    <p class="parrafo bold">{{ $t(localeRoute + 'company') }}</p>
                    <p class="small" v-if="getEmpresa()">{{getEmpresa().nombre}}</p>
                </div>
                <img class="logo" v-if="getEmpresa() && getEmpresa().logo" :src="getEmpresa().logo" />
            </div>
            <div class="bloque contacto">
                <p class="parrafo bold">{{ $t(localeRoute + 'contact') }}</p>
                <ul class="datos">
                    <li v-if="usuario.contacto.email_personal">
                        <img src="images/icon-email.svg">
                        <p class="small">
                            <b>{{ $t(localeRoute + 'personal') }}</b><br>
                            <a :href="'mailto:' + usuario.contacto.email_personal" target="_blank">{{usuario.contacto.email_personal}}</a>
                        </p>
                    </li>
                    <li>
                        <img src="images/icon-email.svg">
                        <p class="small">
                            <b>{{ $t(localeRoute + 'work') }}</b><br>
                            <a :href="'mailto:' + usuario.contacto.email_profesional" target="_blank">{{usuario.contacto.email_profesional}}</a>
                        </p>
                    </li>
                    <li v-if="usuario.contacto.telefono">
                        <img src="images/icon-telf.svg">
                        <p class="small">
                            <b>{{ $t(localeRoute + 'mobile') }}</b><br>
                            <a :href="'telf:' + usuario.contacto.telefono">{{usuario.contacto.telefono}}</a>
                        </p>
                    </li>
                </ul>
            </div>
            <div class="bloque consejera" v-if="usuario.consejera.asignadas.length">
                <v-btn v-if="usuario.consejera.id != 1 && usuario_loggeado.tipo === 'Admin'" class="editar" fab small @click="openModal('modal_consejera')">
                    <v-icon class="icono">mdi-pencil-outline</v-icon>
                </v-btn>
                <p class="parrafo bold">{{usuario.consejera.asignadas.find(co => co.status == 3) ? 'Consejera' : 'Consejera | Pendiente'}}</p>
                <img v-if="usuario.consejera.id && usuario.consejera.asignadas.find(co => co.status == 3) && getConsejera(usuario.consejera.id)" :src="getConsejera(usuario.consejera.id).personales.foto">
                <div v-else-if="usuario.consejera.asignadas.length && usuario_loggeado.tipo != 'Legal'">
                    <img v-if="usuario.consejera.asignadas.find(or => or.order == 1) && getConsejera(usuario.consejera.asignadas.find(or => or.order == 1).id)" :src="getConsejera(usuario.consejera.asignadas.find(or => or.order == 1).id).personales.foto" :class="{rechazada: usuario.consejera.asignadas.find(or => or.order == 1).status == 2}">
                    <img v-if="usuario.consejera.asignadas.find(or => or.order == 2) && getConsejera(usuario.consejera.asignadas.find(or => or.order == 2).id)" :src="getConsejera(usuario.consejera.asignadas.find(or => or.order == 2).id).personales.foto" :class="{rechazada: usuario.consejera.asignadas.find(or => or.order == 2).status == 2}">
                    <img v-if="usuario.consejera.asignadas.find(or => or.order == 3) && getConsejera(usuario.consejera.asignadas.find(or => or.order == 3).id)" :src="getConsejera(usuario.consejera.asignadas.find(or => or.order == 3).id).personales.foto" :class="{rechazada: usuario.consejera.asignadas.find(or => or.order == 3).status == 2}">
                </div>
            </div>
            <div class="bloque legal" v-if="usuario_loggeado.tipo === 'Admin'">
                <p class="parrafo bold">{{ $t(localeRoute + 'showLegal') }}</p>
                <v-switch
                    v-model="usuario.personales.visible_abogados"
                    @change="$emit('updateProfile', visible_abogados)"
                    inset
                    dense
                    hide-details
                ></v-switch>
            </div>
        </div>
        <div class="button-wrapper">
            <p class="boton" @click="openModal('modal_consejera')" v-if="usuario_loggeado.tipo === 'Admin' && usuario.consejera.id == 1 && (!usuario.consejera.asignadas.length || !usuario.consejera.asignadas.find(co => co.status == 0 || co.status == 1))"> {{ $t(localeRoute + 'assignCounselor') }}</p>
            <p class="boton" @click="routerToViviendas" v-if="usuario_loggeado.tipo != 'RRHH' && usuario_loggeado.tipo != 'Legal'">{{ $t(localeRoute + 'selectHomes') }}</p>
            <div class="toggle" :class="{open: toggle_acciones}" v-if="usuario_loggeado.tipo != 'RRHH' && usuario_loggeado.tipo != 'Legal'">
                <p class="boton" @click="clickToggleAcciones" v-click-outside="{ handler: closeToggleActions, closeConditional}">{{ $t(localeRoute + 'otherActions') }} <v-icon class="icono">mdi-menu-down</v-icon></p>
                <ul v-if="toggle_acciones" @click="toggle_acciones = false">
                    <li class="accion" @click="openModal('modal_crear_usuario')" v-if="usuario_loggeado.tipo === 'Admin'">
                        {{ $t(localeRoute + 'editServices') }}
                    </li>
                    <li class="accion" @click="openModal('modal_nuevotrl')" v-else>
                        {{ $t(localeRoute + 'servicesList') }}
                    </li>
                    <li v-if="usuario_loggeado.tipo === 'Admin'" class="accion" @click="openModal('modal_trl_log')">
                        {{ $t(localeRoute + 'seeHistory') }}
                    </li>
                    <li class="accion" @click="openModal('modal_cerrar_trl')" v-if="usuario_loggeado.tipo === 'Admin'">
                        {{usuario.estado == 0 ? 'Cerrar TRL (sin servicio)' : 'Reactivar usuario'}}
                    </li>
                    <li class="accion eliminar" v-if="usuario_loggeado.tipo === 'Admin'" @click="openModal('modal_simple')">
                        {{ $t(localeRoute + 'removeUser') }}
                    </li>
                </ul>
            </div>
        </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Service from '@/components/Service.vue'
import pdfMake from "pdfmake/build/pdfmake"
import pdfFonts from "pdfmake/build/vfs_fonts"
pdfMake.vfs = pdfFonts.pdfMake.vfs;


export default {
	name: 'PanelFicha',
    components: {
        Service,
        },
	props: ["usuario"],

    data() {
        return {
            localeRoute: `message.${[this.$options.name.toLowerCase()]}.`,
            toggle_acciones: false,
            snackbar: false,
            snackbar_text: null,
            ws: null,
            data: null,
            ws_spinner: false,
            toggleConditional: false
        }
    },

    watch: {},
	computed: {
        ...mapState([
            'empresas', 'usuarios', 'usuario_loggeado', 'idiomaGlobal'
        ]),
        servicio_suministros_gestion() {return this.usuario.servicios.find(serv => serv.nombre === 'Suministros') ? this.usuario.servicios.find(serv => serv.nombre === 'Suministros').gestion : null;},
        link_encuesta() {return this.idiomaGlobal === 'es' ? 'https://web508514.typeform.com/to/CWXTD5Uh' : 'https://web508514.typeform.com/to/JaWiM2Nh';}
    },

    methods: {
        getEmpresa() {
            let id = this.usuario.personales.empresa;
            let empresa = this.empresas.find( empresa => empresa.id == id );
            return empresa;
        },
        openModal(modal) {
            this.$emit('openModal', modal);
        },

        getConsejera(id) {
            let consejera = null;
            if (this.usuario_loggeado.tipo === 'RRHH') {
                let trl = this.usuarios.find(usuario => usuario.id == this.usuario.id) || null;
                if (trl.consejera.foto) {
                    consejera = {
                        personales: {
                            foto: trl.consejera.foto,
                            nombre: trl.consejera.nombre,
                            apellidos: trl.consejera.apellidos
                        }
                    }
                }
            } else {
                consejera = this.usuarios.find( usuario => usuario.id == id );
            }
            return consejera;
        },
        routerToViviendas() {
            this.$router.push({ name: 'Viviendas', params: {'usuario': this.usuario }});
        },
        copyToClipboard() {
            let copyTextarea = document.getElementById('link_copy');
            copyTextarea.focus();
            copyTextarea.select();
            try {
                let successful = document.execCommand('copy');
                let msg = successful ? 'successful' : 'unsuccessful';
            } catch (err) {
                console.log('Oops, unable to copy');
            }
            this.snackbar_text = 'Link copiado a tu portapapeles';
            this.snackbar = true;
        },

        // cerrarTrl() {
        //     this.data = {id: this.usuario.id, status: this.usuario.estado == 0 ? 1 : 0, updater: this.usuario_loggeado.id};
        //     this.ws = 'trlStatusUpdate';
        // },
        clickToggleAcciones() {
            var container = this.$el;
            const prev_height = container.scrollHeight;
            this.toggle_acciones = !this.toggle_acciones;
            this.toggleConditional = this.toggle_acciones;
            setTimeout(()=> {
                container.scrollTo({
                    top: container.scrollTop + (container.scrollHeight - prev_height),
                    behavior: 'smooth'
                });
            }, 200);
        },
        closeToggleActions() {
            this.toggle_acciones = false;
            this.toggleConditional = false;
        },
        closeConditional() {
            return this.toggleConditional;
        },
        toList(obj) {
            let list = "";
            for (let prop in obj) {
                if (obj[prop]) {list += prop + ', '}
            }
            return list.replace(/_/g, ' ');
        },
        crearPdf(accion) {
            let conyuge = this.usuario.conyuge ? [
                {
                    text: 'Cónyuge: Sí', style: 'subheader'
                },
                {
                    columns: [
                        {
                            text: [
                                {text: 'Nombre: ', style: 'header'},
                                {text: this.usuario.conyuge.nombre + '\n\n'},
                                {text: 'Nacionalidad: ', style: 'header'},
                                {text: (this.usuario.conyuge.nacionalidad || '') + '\n\n'},
                                {text: 'Email: ', style: 'header'},
                                {text: (this.usuario.conyuge.email || '') + '\n\n'},
                            ]
                        },
                        {
                            text: [
                                {text: 'Apellidos: ', style: 'header'},
                                {text: (this.usuario.conyuge.apellidos || '') + '\n\n'},
                                {text: 'Móvil: ', style: 'header'},
                                {text: this.usuario.conyuge.telefono || '' },
                            ]
                        }
                    ],
                    columnGap: 15
                },
             ] : {
                text: 'Cónyuge: No', style: 'subheader'
            };
            let fechas_disponibles = '';
            this.usuario.preferencias.traslado.fecha_disponible.forEach((fecha, index) => {
                fechas_disponibles += fecha;
                index < this.usuario.preferencias.traslado.fecha_disponible.length ? fechas_disponibles += ', ' : '.';
            });
            let hijos = [];
            this.usuario.preferencias.colegios && this.usuario.preferencias.colegios.hijos ? this.usuario.preferencias.colegios.hijos.forEach((hijo, index) => {
                let hij = [
                    {
                        text: 'Hijo ' + index + 1, style: 'subheader'
                    },
                    {
                        columns: [
                            {
                                text: [
                                    {text: 'Nombre: ', style: 'header'},
                                    {text: (hijo.nombre || '') + '\n\n', fontSize: 12},
                                    {text: 'Sexo: ', style: 'header'},
                                    {text: (hijo.sexo || '') + '\n\n', fontSize: 12},
                                    {text: 'Curso: ', style: 'header'},
                                    {text: hijo.curso || '', fontSize: 12},
                                ]
                            },
                            {
                                text: [
                                    {text: 'Apellidos: ', style: 'header'},
                                    {text: (hijo.apellidos || '') + '\n\n', fontSize: 12},
                                    {text: 'Fecha de nacimiento: ', style: 'header'},
                                    {text: (hijo.nacimiento || '') + '\n\n', fontSize: 12},
                                    {text: 'Idiomas: ', style: 'header'},
                                    {text: hijo.idiomas || '', fontSize: 12},
                                ]
                            }
                        ],
                        columnGap: 15
                    }
                ];
                hijos.push(hij);
            }) : ''
            const colegios = this.usuario.preferencias.colegios.preferencias ? [
                {
                    text: 'COLEGIOS', style: 'header', pageBreak: 'before'
                },
                hijos,
                {
                    text: 'Preferencias colegio', style: 'subheader'
                },
                {
                    text: [
                        {text: 'Tipo: ', style: 'header'},
                        {text: this.toList(this.usuario.preferencias.colegios.preferencias.tipo_colegio) + '\n\n', fontSize: 12},
                        {text: 'Tipo de educación: ', style: 'header'},
                        {text: this.toList(this.usuario.preferencias.colegios.preferencias.tipo_educacion), fontSize: 12}
                    ]
                },
            ] : '';

            let suministros = [];
            if (this.servicio_suministros_gestion) {
                suministros.push({text: 'SUMINISTROS', style: 'header', pageBreak: 'before'});
                ['internet', 'agua', 'luz', 'gas'].forEach(sumi => {
                    let servicio;
                    if (sumi === 'internet') {
                        servicio = [
                            {
                                text: sumi, style: 'subheader'
                            },
                            {
                                columns: [
                                    {
                                        text: [
                                            {text: 'Compañía: ', style: 'header'},
                                            {text: (this.servicio_suministros_gestion[sumi].servicio.compañia || '') + '\n\n', fontSize: 12},
                                            {text: 'Nº ref.: ', style: 'header'},
                                            {text: (this.servicio_suministros_gestion[sumi].servicio.num_ref || '') + '\n\n', fontSize: 12},
                                            {text: 'Comprobación: ', style: 'header'},
                                            {text: (this.servicio_suministros_gestion[sumi].servicio.comprobacion || '') + '\n\n', fontSize: 12},
                                        ]
                                    },
                                    {
                                        text: [
                                            {text: 'Telf.: ', style: 'header'},
                                            {text: (this.servicio_suministros_gestion[sumi].servicio.telefono_asociado || '') + '\n\n', fontSize: 12},
                                            {text: 'Fecha de alta: ', style: 'header'},
                                            {text: (this.servicio_suministros_gestion[sumi].servicio.fecha_alta || '') + '\n\n', fontSize: 12},
                                            {text: 'Otros: ', style: 'header'},
                                            {text: this.servicio_suministros_gestion[sumi].servicio.otros || ''}
                                        ]
                                    }
                                ],
                                columnGap: 15
                            }
                        ]
                    } else {
                        servicio = [
                            {
                                text: sumi, style: 'subheader'
                            },
                            {
                                columns: [
                                    {
                                        text: [
                                            {text: 'Compañía: ', style: 'header'},
                                            {text: (this.servicio_suministros_gestion[sumi].servicio.compañia || '') + '\n\n', fontSize: 12},
                                            {text: 'Nº contrato.: ', style: 'header'},
                                            {text: (this.servicio_suministros_gestion[sumi].servicio.num_contrato || '') + '\n\n', fontSize: 12},
                                            {text: 'Titular: ', style: 'header'},
                                            {text: (this.servicio_suministros_gestion[sumi].servicio.titular || '') + '\n\n', fontSize: 12},
                                            {text: 'Lectura: ', style: 'header'},
                                            {text: this.servicio_suministros_gestion[sumi].servicio.lectura || '', fontSize: 12},
                                        ]
                                    },
                                    {
                                        text: [
                                            {text: 'Telf.: ', style: 'header'},
                                            {text: (this.servicio_suministros_gestion[sumi].servicio.telefono || '') + '\n\n', fontSize: 12},
                                            {text: 'Fecha de alta/domicil.: ', style: 'header'},
                                            {text: (this.servicio_suministros_gestion[sumi].servicio.fecha_alta || '') + '\n\n', fontSize: 12},
                                            {text: 'DNI: ', style: 'header'},
                                            {text: (this.servicio_suministros_gestion[sumi].servicio.dni || '') + '\n\n'},
                                            {text: 'Comprobación: ', style: 'header'},
                                            {text: (this.servicio_suministros_gestion[sumi].servicio.comprobacion || '') + '\n\n'},
                                            {text: 'Otros: ', style: 'header'},
                                            {text: this.servicio_suministros_gestion[sumi].servicio.otros || '', fontSize: 12},
                                        ]
                                    }
                                ],
                                columnGap: 15
                            }
                        ]
                    }
                    suministros.push(servicio);
                });
            }

            let otros_servicios = [];
            this.usuario.servicios.forEach(ser => {
                let servicio;
                if (ser.otros_servicios !== false && ser.nombre !== 'Suministros' && ser.nombre !== 'Servicio cierre') {
                    servicio = [
                        {
                            text: ser.nombre, style: 'subheader'
                        },
                        {
                            columns: [
                                {
                                    text: [
                                        {text: 'Fecha inicio: ', style: 'header'},
                                        {text: (ser.gestion.inicio || '') + '\n\n', fontSize: 12},
                                        {text: 'Otros: ', style: 'header'},
                                        {text: ser.gestion.notas || '', fontSize: 12},
                                    ]
                                },
                                {
                                    text: [
                                        {text: 'Fecha fin: ', style: 'header'},
                                        {text: ser.gestion.fin || ''}
                                    ]
                                }
                            ],
                            columnGap: 15
                        }
                    ]
                } else if (ser.nombre === 'Servicio cierre') {
                    servicio = [
                        {
                            text: ser.nombre, style: 'subheader'
                        },
                        {
                            columns: [
                                {
                                    text: [
                                        {text: 'Fecha Envío carta notificación: ', style: 'header'},
                                        {text: ser.servicio.fecha_envio_notificacion + '\n\n', fontSize: 12},
                                        {text: 'Fecha check-out: ', style: 'header'},
                                        {text: ser.servicio.fecha_check_out + '\n\n', fontSize: 12},
                                        {text: 'Baja internet: ', style: 'header'},
                                        {text: ser.servicio.baja_internet + '\n\n', fontSize: 12},
                                        {text: 'Baja luz: ', style: 'header'},
                                        {text: ser.servicio.baja_luz, fontSize: 12},
                                    ]
                                },
                                {
                                    text: [
                                        {text: 'Devolución fianza: ', style: 'header'},
                                        {text: ser.servicio.devolucion_fianza + '\n\n', fontSize: 12},
                                        {text: 'Baja agua: ', style: 'header'},
                                        {text: ser.servicio.baja_agua + '\n\n', fontSize: 12},
                                        {text: 'Baja gas: ', style: 'header'},
                                        {text: ser.servicio.baja_gas, fontSize: 12},
                                    ]
                                }
                            ],
                            columnGap: 15
                        }
                    ]
                };
                otros_servicios.push(servicio);
            })


            var ficha = {
                pageMargins: [ 60, 60, 60, 40 ],
                styles: {
                    header: {
                        fontSize: 11,
                        bold: true,
                        margin: [0, 30, 0, 0]
                    },
                    subheader: {
                        fontSize: 12,
                        bold: true,
                        lineHeight: 1.5,
                        margin: [0, 25, 0, 5],
                        color: '#A291D6'
                    },
                    defaultStyle: {
                        fontSize: 12,
                        lineHeight: 1.2
                    },
                    bold: {
                        bold: true,
                    }
                },
                header: [
                    {
                        margin: [60, 30, 60, 10],
                        columns: [
                            {
                                width: '30%',
                                text: 'Ficha de usuario',
                                fontSize: 16, bold: true,
                            },
                            {
                                image: "data:image/jpeg;base64,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",
                                fit: [71, 23],
                                alignment: 'right'
                            }
                        ]
                    }
                ],
                content: [
                    {
                        text: 'INFORMACIÓN PERSONAL', style: 'header'
                    },
                    {
                        text: 'Datos personales', style: 'subheader'
                    },
                    {
                        columns: [
                            {
                                text: [
                                    {text: 'Nombre: ', style: 'header'},
                                    {text: this.usuario.personales.nombre + '\n\n'},
                                    {text: 'Nacionalidad: ', style: 'header'},
                                    {text: (this.usuario.personales.nacionalidad || '') + '\n\n'},
                                    {text: 'Dirección actual: ', style: 'header'},
                                    {text: this.usuario.personales.direccion || ''}
                                ]
                            },
                            {
                                text: [
                                    {text: 'Apellidos: ', style: 'header'},
                                    {text: (this.usuario.personales.apellidos || '') + '\n\n'},
                                    {text: 'Idioma preferido: ', style: 'header'},
                                    {text: (this.usuario.personales.idiomas || '') + '\n\n'},
                                    {text: 'Pasaporte/DNI: ', style: 'header'},
                                    {text: this.usuario.personales.pasaporte || '' },
                                ]
                            }
                        ],
                        columnGap: 15
                    },
                    {
                        text: 'Datos de contacto', style: 'subheader'
                    },
                    {
                        columns: [
                            {
                                text: [
                                    {text: 'Email prof.: ', style: 'header'},
                                    {text: (this.usuario.contacto.email_profesional || '') + '\n\n'},
                                    {text: 'Móvil: ', style: 'header'},
                                    {text: this.usuario.contacto.telefono || ''},
                                ]
                            },
                            {
                                text: [
                                    {text: 'Email pers.: ', style: 'header'},
                                    {text: (this.usuario.contacto.email_personal || '') + '\n\n'},
                                    {text: 'Empresa: ', style: 'header'},
                                    {text: this.usuario.personales.empresa ? this.getEmpresa(this.usuario.personales.empresa).nombre : '' },
                                ]
                            }
                        ],
                        columnGap: 15
                    },
                    conyuge,
                    // {
                    //     text: 'Datos bancarios', style: 'subheader'
                    // },
                    // {
                    //     columns: [
                    //         {
                    //             text: [
                    //                 {text: 'Banco: ', style: 'header'},
                    //                 {text: this.usuario.datos_bancarios.banco + '\n\n'}
                    //             ]
                    //         },
                    //         {
                    //             text: [
                    //                 {text: 'IBAN: ', style: 'header'},
                    //                 {text: this.usuario.datos_bancarios.cuenta},
                    //             ]
                    //         }
                    //     ]
                    // },
                    {
                        text: 'PREFERENCIA DE TRASLADO', style: 'header', pageBreak: 'before'
                    },
                    {
                        text: 'Traslado', style: 'subheader'
                    },
                    {
                        columns: [
                            {
                                text: [
                                    {text: 'Fecha traslado: ', style: 'header'},
                                    {text: (this.usuario.preferencias.traslado.fecha_traslado) + '\n\n'},
                                    {text: 'Fechas disponibles para visitas: ', style: 'header'},
                                    {text: fechas_disponibles + '\n\n'},
                                    {text: 'Presupuesto: ', style: 'header'},
                                    {text: this.usuario.preferencias.traslado.presupuesto}
                                ]
                            },
                            {
                                text: [
                                    {text: 'Fecha entrada deseada: ', style: 'header'},
                                    {text:  (this.usuario.preferencias.traslado.fecha_entrada) + '\n\n'},
                                    {text: 'Duración alquiler: ', style: 'header'},
                                    {text:  this.usuario.preferencias.traslado.tiempo_alquiler},
                                ]
                            }
                        ],
                        columnGap: 15
                    },
                    {
                        text: 'Vivienda', style: 'subheader'
                    },
                    {
                        columns: [
                            {
                                text: [
                                    {text: 'Metros cuadrados: ', style: 'header'},
                                    {text: this.usuario.preferencias.vivienda.metros + 'm2 \n\n'},
                                    {text: 'Tipo: ', style: 'header'},
                                    {text: this.toList(this.usuario.preferencias.vivienda.tipo) + '\n\n'},
                                    {text: 'Estado: ', style: 'header'},
                                    {text: this.toList(this.usuario.preferencias.vivienda.estado) + '\n\n'},
                                    {text: 'Características: ', style: 'header'},
                                    {text: this.toList(this.usuario.preferencias.vivienda.caracteristicas) + '\n\n'},
                                    {text: 'Otras preferencias: ', style: 'header'},
                                    {text: this.toList(this.usuario.preferencias.vivienda.otras_preferencias) + '\n\n'},
                                    {text: 'Áreas residenciales: ', style: 'header'},
                                    {text: this.usuario.preferencias.vivienda.areas_residenciales},
                                ]
                            },
                            {
                                text: [
                                    {text: 'Nº de habitaciones: ', style: 'header'},
                                    {text: this.usuario.preferencias.vivienda.habitaciones + '\n\n'},
                                    {text: 'Estilo: ', style: 'header'},
                                    {text: this.toList(this.usuario.preferencias.vivienda.estilo) + '\n\n'},
                                    {text: 'Mascota: ', style: 'header'},
                                    {text: this.usuario.preferencias.vivienda.mascota ? 'Sí \n\n' : 'No' + '\n\n'},
                                    {text: 'Garaje: ', style: 'header'},
                                    {text: this.usuario.preferencias.vivienda.garaje ? this.usuario.preferencias.vivienda.coches_en_presupuesto ? this.usuario.preferencias.vivienda.coches + ' plazas | Incluído en el precio \n\n' : this.usuario.preferencias.vivienda.coches + ' plazas \n\n'  : 'No' + '\n\n'},
                                    {text: 'Otros: ', style: 'header'},
                                    {text: this.usuario.preferencias.vivienda.otros},
                                ]
                            }
                        ],
                        columnGap: 15
                    },
                    colegios,
                    {
                        text: 'VIVIENDA Y CONTRATO', style: 'header', pageBreak: 'before'
                    },
                    {
                        text: 'Datos para la empresa', style: 'subheader'
                    },
                    {
                        columns: [
                            {
                                text: [
                                    {text: 'Fecha de aviso: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.gestion.fecha_aviso || '') + '\n\n', fontSize: 12},
                                    {text: 'Fecha de llegada: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.gestion.fecha_llegada || '') + '\n\n', fontSize: 12},
                                    {text: 'Fecha firma contrato: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.gestion.fecha_firma_contrato || '') + '\n\n', fontSize: 12},
                                    {text: 'Fecha búsqueda colegios: ', style: 'header'},
                                    {text: this.usuario.servicio_vivienda.gestion.fecha_busqueda_colegios || '', fontSize: 12}
                                ]
                            },
                            {
                                text: [
                                    {text: 'Fecha 1er contacto: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.gestion.fecha_primer_contacto || '') + '\n\n', fontSize: 12},
                                    {text: 'Fecha visita a casas: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.gestion.fecha_visita || '') + '\n\n', fontSize: 12},
                                    {text: 'Fecha entrada: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.gestion.fecha_entrada || '') + '\n\n', fontSize: 12},
                                    {text: 'Otros: ', style: 'header'},
                                    {text: this.usuario.servicio_vivienda.gestion.otros || ''}
                                ]
                            }
                        ],
                        columnGap: 15
                    },
                    {
                        text: 'Datos de la vivienda', style: 'subheader'
                    },
                    {
                        text: [
                            {text: 'Dirección: ', style: 'header'},
                            {text: (this.usuario.servicio_vivienda.datos_vivienda.direccion || '') + '\n\n', fontSize: 12},
                            {text: 'Ref. catastral: ', style: 'header'},
                            {text: (this.usuario.servicio_vivienda.datos_vivienda.referencia_catastral || '') + '\n\n\n', fontSize: 12},
                        ]
                    },
                    {
                        columns: [
                            {
                                text: [
                                    {text: 'Nombre propietario: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.datos_vivienda.propietario_nombre || '') + '\n\n', fontSize: 12},
                                    {text: 'DNI propietario: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.datos_vivienda.propietario_dni || '') + '\n\n', fontSize: 12},
                                    {text: 'Dirección propietario: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.datos_vivienda.propietario_direccion || '') + '\n\n\n', fontSize: 12},
                                ]
                            },
                            {
                                text: [
                                    {text: 'Telf. propietario: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.datos_vivienda.propietario_telefono || '') + '\n\n', fontSize: 12},
                                    {text: 'Email propietario: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.datos_vivienda.propietario_email || '') + '\n\n', fontSize: 12},
                                    {text: 'IBAN propietario: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.datos_vivienda.iban || '') + '\n\n', fontSize: 12}
                                ]
                            }
                        ],
                        columnGap: 15
                    },
                    {
                        columns: [
                            {
                                text: [
                                    {text: 'Nombre encargado: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.datos_vivienda.encargado_nombre || '') + '\n\n', fontSize: 12},
                                ]
                            },
                            {
                                text: [
                                    {text: 'Telf. encargado: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.datos_vivienda.encargado_telefono || '') + '\n\n', fontSize: 12},
                                    {text: 'Email encargado: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.datos_vivienda.encargado_email || '') + '\n\n\n', fontSize: 12},
                                ]
                            }
                        ],
                        columnGap: 15
                    },
                    {
                        columns: [
                            {
                                text: [
                                    {text: 'Agencia inmobiliaria: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.datos_vivienda.inmobiliaria_nombre || '') + '\n\n', fontSize: 12},
                                ]
                            },
                            {
                                text: [
                                    {text: 'Telf. inmobiliaria: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.datos_vivienda.inmobiliaria_telefono || '') + '\n\n', fontSize: 12},
                                    {text: 'Email inmobiliaria: ', style: 'header'},
                                    {text: this.usuario.servicio_vivienda.datos_vivienda.inmobiliaria_email || '', fontSize: 12},
                                ]
                            }
                        ],
                        columnGap: 15
                    },
                    {
                        text: [
                            {text: 'Otros: ', style: 'header'},
                            {text: (this.usuario.servicio_vivienda.datos_vivienda.otros || ''), fontSize: 12},
                        ]
                    },
                    {
                        text: 'Contrato de alquiler', style: 'subheader'
                    },
                    {
                        text: [
                            {text: 'Contrato a nombre de: ', style: 'header'},
                            {text: (this.usuario.servicio_vivienda.contrato_alquiler.contrato_nombre || '') + '\n\n', fontSize: 12},
                            {text: 'Firmado por: ', style: 'header'},
                            {text: (this.usuario.servicio_vivienda.contrato_alquiler.contrato_firmado || '') + '\n\n', fontSize: 12},
                        ]
                    },
                    {
                        columns: [
                            {
                                text: [
                                    {text: 'Fecha inicio contrato: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.contrato_alquiler.fecha_inicio || '') + '\n\n', fontSize: 12},
                                    {text: 'Preaviso: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.contrato_alquiler.preaviso || '') + '\n\n', fontSize: 12},
                                    {text: 'Fianza: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.contrato_alquiler.fianza || '') + '\n\n', fontSize: 12},
                                    {text: 'Depósito/aval: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.contrato_alquiler.deposito || '') + '\n\n', fontSize: 12},
                                    {text: 'Comisión agencia: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.contrato_alquiler.comision || '') + '\n\n', fontSize: 12},
                                    {text: 'Inventario fotográfico: ', style: 'header'},
                                    {text: this.usuario.servicio_vivienda.contrato_alquiler.inventario ? 'Sí \n\n' : 'No \n\n', fontSize: 12},
                                    {text: 'Otros: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.contrato_alquiler.otros || '') + '\n\n', fontSize: 12},
                                ]
                            },
                            {
                                text: [
                                    {text: 'Duración obligatoria: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.contrato_alquiler.duracion_obligatoria || '') + '\n\n', fontSize: 12},
                                    {text: 'Renta: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.contrato_alquiler.renta || '') + '\n\n', fontSize: 12},
                                    {text: 'Pagado por: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.contrato_alquiler.fianza_pagador || '') + '\n\n', fontSize: 12},
                                    {text: 'Pagado por: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.contrato_alquiler.deposito_pagador || '') + '\n\n', fontSize: 12},
                                    {text: 'Pagado por: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.contrato_alquiler.comision_pagador || '') + '\n\n', fontSize: 12},
                                    {text: 'Contrato prorrogable: ', style: 'header'},
                                    {text: this.usuario.servicio_vivienda.contrato_alquiler.contrato_prorrogable || '' + '\n\n', fontSize: 12},
                                ]
                            }
                        ],
                        columnGap: 15
                    },
                    {
                        text: 'Seguro hogar (inquilino)', style: 'subheader'
                    },
                    {
                        columns: [
                            {
                                text: [
                                    {text: 'Nombre: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.seguro_hogar.inquilino_nombre || '') + '\n\n', fontSize: 12},
                                    {text: 'Nº póliza: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.seguro_hogar.inquilino_poliza || '') + '\n\n', fontSize: 12},
                                ]
                            },
                            {
                                text: [
                                    {text: 'Telf.: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.seguro_hogar.inquilino_telefono || '') + '\n\n', fontSize: 12},
                                    {text: 'Email: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.seguro_hogar.inquilino_email || '') + '\n\n', fontSize: 12},
                                ]
                            }
                        ],
                        columnGap: 15
                    },
                    {
                        text: [
                            {text: 'Otros: ', style: 'header'},
                            {text: (this.usuario.servicio_vivienda.seguro_hogar.inquilino_otros || ''), fontSize: 12},
                        ]
                    },
                    {
                        text: 'Seguro hogar (propietario)', style: 'subheader'
                    },
                    {
                        columns: [
                            {
                                text: [
                                    {text: 'Nombre: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.seguro_hogar.propietario_nombre || '') + '\n\n', fontSize: 12},
                                    {text: 'Nº póliza: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.seguro_hogar.propietario_poliza || '') + '\n\n', fontSize: 12},
                                ]
                            },
                            {
                                text: [
                                    {text: 'Telf.: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.seguro_hogar.propietario_telefono || '') + '\n\n', fontSize: 12},
                                    {text: 'Email: ', style: 'header'},
                                    {text: (this.usuario.servicio_vivienda.seguro_hogar.propietario_email || '') + '\n\n', fontSize: 12},
                                ]
                            }
                        ],
                        columnGap: 15
                    },
                    {
                        text: [
                            {text: 'Otros: ', style: 'header'},
                            {text: (this.usuario.servicio_vivienda.seguro_hogar.propietario_otros || ''), fontSize: 12},
                        ]
                    },
                    suministros,
                    {
                        text: 'OTROS SERVICIOS', style: 'header', pageBreak: 'before'
                    },
                    otros_servicios

                ],
            }
            accion != 'imprimir' ? pdfMake.createPdf(ficha).download(this.usuario.personales.apellidos + '.pdf') : pdfMake.createPdf(ficha).print();
        },
        enviarEncuesta() {
            let copyTextarea = document.getElementById('link_copy_encuesta');
            copyTextarea.focus();
            copyTextarea.select();
            try {
                let successful = document.execCommand('copy');
                let msg = successful ? 'successful' : 'unsuccessful';
            } catch (err) {
                console.log('Oops, unable to copy');
            }
            this.snackbar_text = 'Link de encuesta copiado a tu portapapeles';
            this.snackbar = true;
        },
        onSuccess(response) {
            this.ws = null;
            this.data = null;
            this.ws_spinner = false;
            if (response.ws === 'trlStatusUpdate') {
                this.$emit('refreshUser', true);
            } else if (response.ws === 'userList') {
                let usuarios = [...this.usuarios, ...response.data];
                this.$store.dispatch('setUsuarios', usuarios);
            }
        }
	},
    created: function() {
        this.console = window.console;
    },
    mounted: function() {
        if (this.usuario_loggeado.tipo === 'Legal') {
            this.data = {queries: '?type=cons,admin'}
            this.ws = 'userList';
        }
    }
}
</script>
<style scoped lang="scss">
.v-application #app .ficha {
    text-align: center;
    .tipo {
        position: absolute;
        top: 6.5em;
        left: 0;
        color: white;
        padding: .5em;
        width: 25%;
        border-radius: 0px 50px 50px 0px;
    }
    .foto {
        position: relative;
        text-align: center;
        .avatar {
            // width: 55%;
            width: 130px;
            height: 130px;
            // object-fit: cover;
        }
        .finalizado {
            position: absolute;
            width: 60%;
            top: 35%;
            left: 20%;
            text-align: center;
            background-color: white;
            padding: .5em;
            border: 0.5px solid #373737;
            border-radius: 10em;
        }
    }
    .nombre {
        margin: 1em auto 1.8em;
        font-size: 1.2em;
    }
    .acciones_rapidas {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1.8em;
        svg {
            z-index: 50;
            margin: 0 1em;
            cursor: pointer;
        }
        .link_copy {position: absolute; opacity: 0;}
    }
    .wrapper-bloque-panel {
        display: block;
        width: 100%;
    }
    .button-wrapper {
        .boton {
            width: 100%;
            margin-bottom: 1em;
        }
    }
    .bloque {
        background-color: var(--gray01);
        margin: 1em auto;
        padding: 1em;
        text-align: left;
        border-radius: 3px;
        .parrafo {
            margin-bottom: .5em;
        }
        .datos {
            display: flex;
            flex-flow: column;
            padding-left: 0;
            li {
                display: flex;
                align-items: center;
                overflow: hidden;
                img {
                    width: 1.5em;
                    height: 1.5em;
                    object-fit: contain;
                    margin: .7em .8em .7em 0;
                }
                .small {line-height: 1.3em; text-overflow: ellipsis;}
            }
        }
        &.empresa {
            display: flex;
            flex-flow: row;
            .izda { margin-right: .5em;}
            .logo {
                margin-left: auto;
                width: 25%;
                max-height: 3em;
                object-fit: contain;
            }
        }
        &.consejera {
            position: relative;
            img {
                position: relative;
                border-radius: 50%;
                width: 3em;
                height: 3em;
                object-fit: cover;
                margin-right: 1em;
                &.rechazada {
                    border: 2px solid #f76d6d;
                    &::after {
                        content: '';
                        top: 0;
                        left: 0;
                        width: 3em;
                        height: 3em;
                        background-color: #f76d6d;
                        opacity: .5;
                    }
                }
            }
            .editar {
                position: absolute;
                top: 1em;
                right: 1em;
                width: 25px;
                height: 25px;
                box-shadow: var(--sombra_ext);
                background-color: white;
                opacity: 1!important;
                .icono {
                    width: 15px;
                    height: 15px;
                    color: var(--gray04);
                    font-size: 15px;
                }
            }
        }
        &.legal {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .parrafo {margin-bottom: 0;}
            ::v-deep .v-input {
                &.v-input--selection-controls {margin-top: 0;}
            }
        }
    }
    &> .boton, .toggle .boton {
        width: 100%;
        margin: .5em 0;
    }
    .toggle {
        &.open {
            margin-bottom: 2em;
        }
        .boton {
            background: white;
            color: var(--purple03);
            border: 1px solid var(--purple03);
            .icono {
                position: absolute;
                right: 5px;
                top: 27px;
                transform: translateY(-50%);
                color: var(--purple03);
            }
            &:hover {
                background-color: rgba(162,145,214,.1);
            }
        }
        ul {
            position: relative;
            .accion.eliminar {
                color: #f76d6d;
                &:hover {font-weight: bold;}
            }
        }
    }
}

@media (max-width: 900px) {
    .v-application #app .ficha {
        .tipo {
            top: 4em;
        }
        .wrapper-bloque-panel {
            display: flex;
            flex-wrap: wrap;
            .bloque {
                width: 45%;
            }
        }
        .button-wrapper {
            width: 97%;
            display: flex;
            .boton,
            .toggle {
                flex: 1 1 33%;
            }
            .boton {
                align-self: flex-start;
                margin: .5em;
            }
        }
        .user-info-wrapper {
            display: flex;
            align-items: center;
            padding-top: 40px;
            margin-bottom: 20px;
            .foto {
                margin-right: 2em;
                .finalizado {
                    font-size: 10px;
                    width: 100%;
                    left: 0;
                }
                .avatar {
                    width: 85px;
                    height: 85px;
                }
            }
            .nombre {
                margin: 0 0 1em;
                text-align: left;
                font-size: 1.4em;
            }
            .acciones_rapidas {
                margin-bottom: 1em;
                justify-content: flex-start;
                svg {
                    margin: 0 1.5em;
                    height: 25px;
                    width: 25px;
                    &:first-child {
                        margin-left: 0;
                    }
                }
            }
            .user-wrapper {
                display: flex;
                flex-direction: column;
            }
        }
    }
}

@media (max-width: 760px) {
    .v-application #app .ficha {
        .wrapper-bloque-panel {
            display: block;
            .bloque {
                width: 100%;
            }
        }
        .button-wrapper {
            flex-wrap: wrap;
            .boton {
                margin-right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                &:first-of-type{
                    padding: .7em 1.7em;
                }
            }
        }
        .bloque {
            .datos {
                flex-direction: row;
                flex-wrap: wrap;
                li {
                    flex: 0 1 auto;
                    margin-right: 1.5rem;
                }
            }
        }
        .user-info-wrapper {
            display: flex;
            align-items: center;
            margin-bottom: 20px;
        }
    }
 }
</style>
